import { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";

import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import FRDevicesConfigCard from "../../../components/card/FRDevicesConfigCard";
import FRConfigurationsCard from "../../../components/card/FRConfigurationsCard";
import { useState } from "react";

const FRConfig = () => {
  const { t } = useTranslation();

  const [selectedDeviceIPAddresses, setSelectedDeviceIPAddresses] = useState<
  string[]
  >([]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="flex flex-col gap-4 md:gap-8">
        <BackButtonWrapper>
          <h1 className="text-xl md:text-2xl dark:text-white">
            {t("frConfig")}
          </h1>
        </BackButtonWrapper>

        <div className="flex flex-col gap-4 md:gap-8">
          <FRDevicesConfigCard
            setSelectedDeviceIPAddresses={setSelectedDeviceIPAddresses}
          />
          <FRConfigurationsCard
            selectedDeviceIPAddresses={selectedDeviceIPAddresses}
          />
        </div>
      </div>
    </>
  );
};

export default FRConfig;
